// Маршрут, у которого экран зависит от роли: у админа — форма редактирования, у остальных — карточка с их действиями.
import { defineAsyncComponent, defineComponent, h } from "vue";

/** roleComponent({ admin: () => import(...) }, () => import(...)) — по роли из localStorage выбирает компонент. */
export const roleComponent = (byRole, fallback) => {
  const cache = new Map();
  const asyncFor = (loader) => {
    if (!cache.has(loader)) cache.set(loader, defineAsyncComponent(loader));

    return cache.get(loader);
  };

  return defineComponent({
    name: "RoleComponent",
    setup() {
      // роль читается при каждом открытии страницы (после смены пользователя без перезагрузки)
      return () => h(asyncFor(byRole[localStorage.getItem("userrole")] || fallback));
    },
  });
};
